export const DEFAULT_CONFIGURATION_TITLE = 'AI Loan Assistant';

export const SWITCH_CONFIGURATION_CONFIRMATION_TITLE = 'Switch configuration?';

export const SWITCH_CONFIGURATION_CONFIRMATION_ACCEPT = 'Switch';

export const SWITCH_CONFIGURATION_CONFIRMATION_CANCEL = 'Cancel';
